import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { handleSessionExpired, isTokenExpiredError } from './utils/auth';
import EmailComposer from './components/EmailComposer';
import UnsubscribePage from './components/UnsubscribePage';
import HistoryPage from './components/HistoryPage';
import TrackingDashboard from './components/TrackingDashboard';
import WhatsAppPage from './components/WhatsAppPage';
import EmailInbox from './components/EmailInbox';
import ContactsPage from './components/ContactsPage';
import ScheduledMailsPage from './components/ScheduledMailsPage';
import './App.css';

function App() {
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (isTokenExpiredError(error)) {
          const message = error.response?.data?.error || 'Your mail session has expired. Please sign in again.';
          handleSessionExpired(message);
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<EmailComposer />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/tracking" element={<TrackingDashboard />} />
          <Route path="/whatsapp" element={<WhatsAppPage />} />
          <Route path="/inbox" element={<EmailInbox />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/scheduled" element={<ScheduledMailsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
